import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: clear-button;

  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  pointer-events: auto;
  user-select: none;

  background: ${theme.colors.n100};

  border-radius: ${theme.borderRadius.circle};

  transition: background ${theme.transition.leave} ease;

  & svg {
    width: 8px;
    height: 8px;

    pointer-events: none;
    user-select: none;

    color: ${theme.colors.n800};
  }

  &:hover {
    background: ${theme.colors.n200};

    & svg {
      color: ${theme.colors.black};
    }
  }
`

export const ClearButton = styled('div')(baseStyles)
